export default __webpack_public_path__ + "static/media/dumble-squats.3a2b30bb.png";